import React from "react";
import { Chip } from "@mui/material";
import PublicIcon from "@mui/icons-material/Public";

const SkillChip = ({ label, acquired = false, expired = false }) => {
    return (
        <Chip
            icon={<PublicIcon fontSize={"small"} />}
            color="primary"
            variant={acquired === true ? "filled" : "outlined"}
            className="chip"
            label={label}
            disabled={expired}
        />
    );
};

export default SkillChip;
